import { View } from 'react-native';

export const CardBlur = () => {
    return <View />;
};
